// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 10H22V22H16V16H8V22H2V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 22V18H14V22H10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 2H9V4H10V8H20V4H21V2ZM15.0039 4.99805V7.00195H13V4.99805H15.0039Z"}}]};

const Building4FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'building-4-filled',
    ref,
    icon: element,
  },
));

Building4FilledIcon.displayName = 'Building4FilledIcon';

export default Building4FilledIcon;
